// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__JAJ_b","fadeInOut":"styles_fadeInOut__02by_","loader":"styles_loader__7TYEL"};